/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import moment from "moment";
import { Modal, Tag, Tooltip } from 'antd';
import { MoreMenu, CustomIcon, MoreTags } from 'datastake-daf/dist/components';
import ModuleTags from "./components/ModuleTags";
import modules from "../../../components/ModuleLoader/modules";
import { mmtTheme } from "../../../constants/mmtTheme";
import { tifTheme } from "../../../constants/tifTheme";
import { tazamaTheme } from "../../../constants/tazamaTheme";
import { getInterface } from "../../../helpers/user";
import { formatClassname } from "datastake-daf/src/helpers/ClassesHelper";

export const MODAL_WIDTH = 650;

export const renderApplicationLabel = ({ mod = '', title, appObject = {} }) => {
  const _interface = (appObject?.interfaces || []).find((i) => i.value === mod.interface)?.label || mod.interface.toUpperCase();
  return `${title} - ${_interface}`;
}

export const renderApplicationTag = ({ mod = '', t = (s) => s, appObject = {}, access }) => {
  const _interface = (appObject?.interfaces || []).find((i) => i.value === mod.interface)?.label || mod.interface.toUpperCase();

  switch (mod.app) {
    case 'mmt':
      return (
        <div key={mod.app} style={{ background: mmtTheme.colorPrimary7 }} className={formatClassname(['app-tag check-tabs', access && 'disabled'])}>
          <div className="flex flex-column justify-content-center">
            <div className="bubble-icon">
              <CustomIcon
                style={{ marginTop: 3, marginLeft: 2 }}
                name="PMESmallLogo" width={7} height={7} color={mmtTheme.colorPrimary7} />
            </div>
          </div>
          <span>
            {_interface}
          </span>
        </div>
      );
    case 'tif':
      return (
        <div key={mod.app} style={{ background: tifTheme.colorSecondary }} className={formatClassname(['app-tag check-tabs', access && 'disabled'])}>
          <div className="flex flex-column justify-content-center">
            <CustomIcon name="TifSmallLogo" width={12} height={12} color="white" />
          </div>
          <span>
            {_interface}
          </span>
        </div>
      );
    case 'tazama':
      return (
        <div key={mod.app} style={{ background: tazamaTheme.colorSecondary }} className={formatClassname(['app-tag check-tabs', access && 'disabled'])}>
          <div className="flex flex-column justify-content-center">
            <CustomIcon name="TazamaSmallLogo" width={12} height={12} color="white" />
          </div>
          <span>
            {_interface}
          </span>
        </div>
      );
    default:
  }
};

export const renderUserRole = ({ role = {}, t = (s) => s }) => {
  const renderIcon = () => {
    if (role.isAdmin) {
      return <CustomIcon name="DatastakeSmallLogo" width={12} height={12} color="white" />
    }
    switch (role.app) {
      case 'mmt':
        return (
          <div className="bubble-icon" style={{ background: mmtTheme.colorPrimary }}>
            <CustomIcon style={{ marginTop: 3, marginLeft: 2 }} name="PMESmallLogo" width={7} height={7} color="white" />
          </div>
        );
      case 'tazama':
        return <CustomIcon name="TazamaSmallLogo" width={12} height={12} color={tazamaTheme.colorSecondary} />
      case 'tif':
        return <CustomIcon name="TifSmallLogo" width={12} height={12} color={tifTheme.colorSecondary} />
      default:
        return null;
    }
  };

  return (
    <div key={role.value} className="app-tag white-tag check-tabs">
      <div className="flex flex-column justify-content-center">
        {renderIcon()}
      </div>
      <span>{t(role.label)}</span>
    </div>
  );
}

export const getColumns = ({
  t = (s) => s,
  setSelectedUser = () => { },
  onDisable = () => { },
  getCountry = (s) => s,
  onDeclineRequest = () => { },
  onReactivate = () => { },
  setUserToReview = () => { },
  onResendVerification = () => { },
  view = 'default',
  options = {},
  applications = [],
}) => [
    {
      title: t("Organisation ID"),
      dataIndex: "userId",
      key: "userId",
      show: true,
      width: 150,
      ellipsis: true,
      render: (v) => {
        return <Tooltip title={v}>{v}</Tooltip>;
      },
    },
    {
      title: t("Email"),
      dataIndex: "email",
      key: "email",
      show: true,
      ellipsis: true,
      render: (v, all) => {
        return <Tooltip title={all?.admin?.email}>{all?.admin?.email}</Tooltip>
      },
    },
    {
      title: t("Organisation name"),
      dataIndex: "name",
      key: "name",
      show: true,
      ellipsis: true,
      render: (v) => {
        return <Tooltip title={v}>{v}</Tooltip>;
      },
    },
    {
      title: t("Category"),
      dataIndex: "category",
      key: "category",
      show: true,
      ellipsis: true,
      render: (v) => {
        const _item = (options?.stakeholderCategoryOptions || []).find((o) => o.value === v);
        const _v = _item ? _item.label : v;
        return <Tooltip title={_v}>{_v}</Tooltip>
      },
    },
    {
      title: t("Country"),
      dataIndex: "country",
      key: "country",
      show: true,
      ellipsis: true,
      render: (v) => {
        const _v = getCountry(v);
        return <Tooltip title={_v}>{_v}</Tooltip>;
      },
    },
    {
      title: t("Users"),
      dataIndex: "users",
      key: "users",
      show: true,
      ellipsis: true,
      render: (v) => <Tooltip title={v?.length || 0}>{v?.length || 0}</Tooltip>,
      width: 100,
    },
    {
      title: t("Deactivation Reason"),
      dataIndex: "deactivationReason",
      key: "deactivationReason",
      show: view === 'blocked',
      ellipsis: true,
      render: (v, u) => {
        if (u?.admin?.status === 'merged' || u.status === 'merged') {
          return <Tooltip title="Merged">Merged</Tooltip>
        }
        if (u?.admin?.approvalStatus === 'declined') {
          return <Tooltip title="Denied">Denied</Tooltip>
        }
        return <Tooltip title="Disabled">Disabled</Tooltip>
      },
    },
    {
      title: t("Deactivation Date"),
      dataIndex: "deactivationDate",
      key: "deactivationDate",
      show: view === 'blocked',
      ellipsis: true,
      render: (v, u) => {
        const _v = u.status === 'merged' ? moment(u?.statusChangeDate || u?.updatedAt).format('DD MMM YYYY') : moment(u?.admin?.statusChangeDate || u?.admin?.updatedAt).format('DD MMM YYYY');
        return <Tooltip title={_v}>{_v}</Tooltip>
      },
    },
    {
      title: t("Email Verified"),
      dataIndex: "emailVerified",
      key: "emailVerified",
      ellipsis: true,
      show: ['requests', 'blocked'].includes(view),
      render: (v, u) => {
        if (u?.admin?.emailVerified) {
          return <Tooltip title="Email Is verified from the user">
            <Tag color="green">{t("Yes")}</Tag>
          </Tooltip>
        }
        return <Tooltip title={t('User needs to verify their email address in order to approve it')}>
          <Tag color="red">{t("No")}</Tag>
        </Tooltip>
      },
    },
    {
      title: t("Application"),
      dataIndex: "dueDeligenceRole",
      key: "role",
      show: true,
      ellipsis: true,
      width: 250,
      render: (cell, data) => {
        let apps = (data.apps || []).filter((a) => a.access);

        if (view === 'requests') {
          apps = (data.apps || []);
        }

        return (
          <ModuleTags>
            <MoreTags
              values={apps.map((m) => {
                const appObject = applications.find((a) => a.app === m.app) || {};

                return {
                  renderTag: () => renderApplicationTag({ mod: m, t, appObject, access: view === 'requests' ? m.access : undefined }),
                  label: renderApplicationLabel({ title: appObject.title, appObject, mod: m }),
                  value: m.app,
                };
              })}
              maxWidthCont={80}
              maxTextCont={60}
              diff={60}
            />
          </ModuleTags>
        );
      }
    },
    {
      title: t(""),
      key: "actions",
      show: view !== 'default-merger',
      ellipsis: true,
      fixed: 'right',
      width: 60,
      render: (cell, data) => {
        if ((view === 'blocked' && !data.companyDisabled) || data.status === 'merged') {
          return null;
        }

        const items = [
          view === 'default' ? {
            key: "editPermissions",
            disabled: !data?.admin?.emailVerified,
            onClick: () => {
              setSelectedUser(data);
            },
            label: t(view === 'requests' ? 'Activate' : 'Edit Account Permissions'),
          } : null,
          view === 'blocked' ? {
            key: "reactivate",
            disabled: !data?.admin?.emailVerified,
            onClick: () => {
              const apps = data.apps || [];

              if (apps.length === 1) {
                Modal.confirm({
                  title: (
                    <div>
                      <div>{t('Are you sure you want to reactive this user?')}</div>
                    </div>
                  ),
                  onOk: () => onReactivate(data),
                  cancelText: t('No'),
                  okText: 'Yes',
                  closable: true,
                })
              } else {
                setSelectedUser({ ...data, modalView: 'blocked' });
              }
            },
            label: t('Activate'),
          } : null,
          view === 'default' ? {
            key: "disable",
            onClick: () => {
              Modal.confirm({
                title: (
                  <div>
                    <div>{t('Are you sure you want to disable this organisation?')}</div>
                    <div>{t('All it’s users are going to be disabled as well.')}</div>
                  </div>
                ),
                onOk: () => onDisable(data),
                cancelText: t('No'),
                okText: 'Yes',
                closable: true,
              })
            },
            label: t('Disable Account'),
          } : null,
          view === 'requests' ? {
            key: "review",
            disabled: !data?.admin?.emailVerified,
            onClick: () => {
              setUserToReview(data);
            },
            label: t('Review Request'),
          } : null,
          !data?.admin?.emailVerified && ['requests', 'blocked'].includes(view) ? {
            key: "resendverification",
            onClick: () => onResendVerification(data?.admin?.id),
            label: t('Resend Verification')
          } : null,
        ]

        return (
          <MoreMenu items={items} />
        );
      },
    },
  ];

export const getExpandTableColumns = ({
  t = (s) => s,
  impersonateUser = () => { },
  onDisable = () => { },
  reactivateUser = () => { },
  view = 'default',
  userRoles = [],
  setTransferRightsUser = () => { },
  setUserTypeUser = () => { },
  onResendVerification = () => { },
  applications = [],
}) => [
    {
      title: t("User ID"),
      dataIndex: "userId",
      key: "userId",
      show: true,
      width: view === 'default' ? 180 : 150,
      ellipsis: true,
      render: (v) => {
        return <Tooltip title={v}>{v}</Tooltip>;
      },
    },
    {
      title: t("Email"),
      dataIndex: "email",
      key: "email",
      show: true,
      ellipsis: true,
      render: (v, all) => <Tooltip title={v}>{v}</Tooltip>,
    },
    {
      title: t("First Name"),
      dataIndex: "firstName",
      key: "firstName",
      show: true,
      ellipsis: true,
      render: (v) => {
        return <Tooltip title={v}>{v}</Tooltip>;
      },
    },
    {
      title: t("Last Name"),
      dataIndex: "lastName",
      key: "lastName",
      show: true,
      ellipsis: true,
      render: (v) => {
        return <Tooltip title={v}>{v}</Tooltip>;
      },
    },
    {
      title: t("Status"),
      dataIndex: "status",
      key: "status",
      show: true,
      ellipsis: true,
      render: (role) => {
        switch (role) {
          case 'active':
            return (
              <Tag color="green">{t("Active")}</Tag>
            )
          case 'inactive':
            return (
              <Tag color="red">{t("Inactive")}</Tag>
            )
          case 'pending':
            return <Tag color="orange">{t("Pending")}</Tag>;

          case 'merged':
            return <Tag>{t("Merged")}</Tag>;
          default:
            return '--';
        }
      }
    },
    {
      title: t("Role"),
      dataIndex: "role",
      key: "role",
      width: 250,
      show: true,
      ellipsis: true,
      render: (role, data) => {
        const apps = Object.keys(data.apps || {})
          .filter((v) => data.apps[v].status === 'active')
          .map((k) => ({ ...data.apps[k], app: k, appObject: applications.find((a) => a.app === k) }));

        const roles = apps.map((app) => userRoles.find((r) => r.value === app.role));

        return (
          <MoreTags
            values={roles.map((role) => ({
              renderTag: () => renderUserRole({ role, userRoles, t }),
              value: role?.value,
              label: role?.label,
            }))}
          />
        )
      }
    },
    {
      title: t(""),
      key: "actions",
      fixed: 'right',
      show: view === 'default' || view === 'blocked',
      ellipsis: true,
      width: 60,
      render: (cell, data) => {
        if ((view === 'blocked' && data.companyDisabled) || data.status === 'merged') {
          return null;
        }

        const apps = (data.companyObject.apps)
          .filter((v) => v.access)
          .map((app) => ({ ...app, appObject: applications.find((a) => a.app === app.app) }));

        const items = view === 'default' ? [
          data.isAdmin ? {
            key: "transferRights",
            onClick: () => setTransferRightsUser(data),
            label: t('Transfer Administrator Rights'),
          } : null,
          !data.isAdmin ? {
            key: "userType",
            onClick: () => setUserTypeUser(data),
            disabled: data.status === 'pending' && data.invitationToken,
            label: t('Edit User Role'),
          } : null,
          !data.isAdmin ? {
            key: "disable",
            onClick: () => {
              Modal.confirm({
                title: (
                  <div>
                    <div>{t('Are you sure you want to disable this user?')}</div>
                  </div>
                ),
                onOk: () => onDisable(data),
                cancelText: t('No'),
                okText: 'Yes',
                closable: true,
              })
            },
            label: t('Remove User'),
          } : null,
          {
            key: "impersonate",
            disabled: data.status === 'pending' && data.invitationToken,
            label: t('Impersonate'),
            children: apps.map((app) => {
              const _interface = getInterface({ data: app, app });

              return {
                key: app.app,
                label: app?.appObject?.title,
                onClick: () => impersonateUser(data.id, _interface, app.appObject),
              }
            })
          },
        ] : view === 'blocked' ? [
          {
            disabled: !data?.emailVerified,
            key: "reactivateUser",
            onClick: () => reactivateUser(data.id),
            label: t('Reactivate'),
          }
        ] : [];

        const allItems = [
          ...items,
          !data?.emailVerified && ['requests', 'blocked'].includes(view) ? {
            key: "resendverification",
            onClick: () => onResendVerification(data?.id),
            label: t('Resend Verification'),
          } : null,
        ]

        return (
          <MoreMenu items={allItems} />
        );
      },
    },
  ];

export const TABS = {
  ACTIVE: 'active',
  REQUESTS: 'requests',
  BLOCKED: 'blocked',
};

export const getFiltersConfig = ({ activeFilters, t, userRoles = [], applications = [], options = {} }) => [
  {
    key: 'application',
    label: 'Application',
    optionsName: 'application',
    placeholder: `${t('Select')} ${t('Application')}`,
    type: 'select',
    items: applications.map((app) => ({
      label: app.title, value: app.app,
    })),
  },
  {
    key: 'userType',
    label: 'User type',
    optionsName: 'userType',
    placeholder: `${t('Select')} ${t('User type')}`,
    type: 'select',
    renderItems: (activeFilters = {}) => userRoles.filter((role) => role.app === activeFilters.application),
  },
  {
    key: 'category',
    label: 'Category',
    optionsName: 'category',
    placeholder: `${t('Select')} ${t('Category')}`,
    type: 'select',
    items: options?.stakeholderCategoryOptions || [],
  },
  {
    key: 'country',
    label: 'Country',
    optionsName: 'country',
    placeholder: `${t('Select')} ${t('Country')}`,
    type: 'select',
    items: options?.countries || [],
  },
]

export const tabs = [
  { key: TABS.ACTIVE, label: 'Active' },
  { key: TABS.REQUESTS, label: 'Requests', showRequests: true },
  { key: TABS.BLOCKED, label: 'Blocked' },
]

export const tabKeys = tabs.map((t) => t.key);

export const mapOrganisation = (user) => {
  if (user?.company) {
    user.organisationName = user.company.name;
    user.key = user.company.id;
  } else {
    user.organisationName = user?.name;
    user.key = user?.id;
  }

  return user;
}

export const getMappedInputs = ({
  t = (s) => s,
  countries = [],
  idOptions = [],
  emailOptions = [],
  options,
  data = {},
  itemsToMerge = [],
}) => ({
  userId: {
    inputType: 'select',
    placeholder: t('Select ID'),
    columnConfig: {
      title: t('Organisation ID'),
      dataIndex: "userId",
      key: "userId",
      search: true,
      mergePos: 0,
      inheritFromFirstItem: true
    },
    onChangeValues: ({ key = '', value = null, updateData = () => { } }) => {
      const _selectOrg = itemsToMerge.find((v) => v.userId === value);
      if (_selectOrg) {
        updateData(key, value);
        updateData('email', _selectOrg?.admin?.email);
        updateData('organisationName', _selectOrg?.name);
        updateData('category', _selectOrg?.category);
        updateData('country', _selectOrg?.country);
        updateData(
          'module',
          (Object.keys(_selectOrg?.modules || {})[0] || '').toLocaleUpperCase()
        );
      }
    },
    options: idOptions,
  },
  email: {
    inputType: 'select',
    placeholder: t('Select email'),
    disabled: true,
    columnConfig: {
      title: t('Email'),
      dataIndex: "email",
      key: "email",
      search: true,
      mergePos: 1,
      inheritFromFirstItem: true
    },
    options: emailOptions,
  },
  organisationName: {
    inputType: 'text',
    placeholder: t('Type organisation name'),
    disabled: true,
    columnConfig: {
      title: t('Organisation Name'),
      dataIndex: "organisationName",
      key: "organisationName",
      search: true,
      mergePos: 2,
    },
  },
  category: {
    inputType: 'select',
    placeholder: t('Select category'),
    disabled: true,
    columnConfig: {
      title: t('Category'),
      dataIndex: "category",
      key: "category",
      search: true,
      mergePos: 3,
      inheritFromFirstItem: true
    },
    options: options.stakeholderCategoryOptions,
  },
  country: {
    inputType: 'select',
    placeholder: t('Select country'),
    disabled: true,
    columnConfig: {
      title: t('Country'),
      dataIndex: "category",
      key: "category",
      search: true,
      mergePos: 4,
      inheritFromFirstItem: true
    },
    options: countries
  },
  users: {
    inputType: 'text',
    disabled: true,
    columnConfig: {
      title: t('Users'),
      dataIndex: "users",
      key: "users",
      mergePos: 5,
    },
  },
  module: {
    inputType: 'select',
    placeholder: t('Select module'),
    disabled: true,
    columnConfig: {
      title: t('Module'),
      dataIndex: "module",
      key: "module",
      search: true,
      mergePos: 6,
      inheritFromFirstItem: true
    },
    options: modules.map((m) => ({
      value: m.code, label: m.code,
    }))
  },
})
